import ContentCard from "./ContentCard.jsx"

export default ContentCard;